import { cn } from "@dune/ui";
import React, { useState } from "react";

interface WordViewerProps {
	url: string;
	className?: string;
	fileName?: string;
}

export const WordViewer: React.FC<WordViewerProps> = ({
	url,
	className = "",
	fileName = "Document Word",
}) => {
	const [viewerError, setViewerError] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;

	if (viewerError) {
		return (
			<div
				className={cn(
					"h-full w-full flex items-center justify-center",
					className,
				)}
			>
				<div className="text-center space-y-4 max-w-md p-8">
					<div className="space-y-2">
						<h3 className="text-lg font-semibold text-gray-900">
							Aperçu non disponible
						</h3>
						<p className="text-gray-600">
							L'aperçu du document Word n'est pas disponible en ligne. Vous
							pouvez le télécharger pour le visualiser.
						</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={cn("word-viewer h-full w-full relative", className)}>
			{isLoading && (
				<div className="absolute inset-0 flex items-center justify-center bg-white/90 z-10">
					<div className="flex flex-col items-center justify-center space-y-4">
						<div className="relative w-12 h-12">
							<div className="absolute inset-0 border-3 border-gray-200 rounded-full" />
							<div className="absolute inset-0 border-3 border-transparent border-t-blue-600 rounded-full animate-spin" />
						</div>
						<p className="text-sm text-gray-500">Chargement du document...</p>
					</div>
				</div>
			)}

			<iframe
				src={googleViewerUrl}
				title={fileName}
				className="w-full h-full border-0"
				style={{ minHeight: "84vh" }}
				onLoad={() => setIsLoading(false)}
				onError={() => {
					setIsLoading(false);
					setViewerError(true);
				}}
			/>
		</div>
	);
};
